import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "filters mt-16 mb-40" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex--justify-center"
}
const _hoisted_3 = {
  key: 1,
  class: "filters__row"
}
const _hoisted_4 = { class: "filters__column filters__column--space-between" }
const _hoisted_5 = { class: "full-width" }
const _hoisted_6 = {
  key: 0,
  class: "grid grid--stretch grid--xs flex flex--wrap full-width mb-8"
}
const _hoisted_7 = {
  key: 1,
  class: "mb-16"
}
const _hoisted_8 = { class: "filters__column" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode($setup["SearchFilterComponent"], {
      "store-key": "projects",
      "input-placeholder": "Search for a project",
      "show-search-input": $setup.active_tab !== 'example_projects'
    }, null, 8 /* PROPS */, ["show-search-input"]),
    ($setup.user_is_staff)
      ? (_openBlock(), _createBlock(_Transition, {
          key: 0,
          name: "fade",
          persisted: ""
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_1, [
              ($setup.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode($setup["PageLoaderComponent"], { small: true })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        ($setup.selected_dropdown_filter_components.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selected_dropdown_filter_components, (filter) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: 'dropdown-filter-component-' + filter.value,
                                  class: "grid__item a4-12 c6-12 mb-8"
                                }, [
                                  _createVNode($setup["DropdownFilterComponent"], {
                                    "store-key": "projects",
                                    label: filter.label,
                                    "filter-key": filter.value,
                                    "filter-options-key": filter.options_key ?? null,
                                    "get-options-method": filter.get_options_method ?? null,
                                    "search-disabled": filter.search_disabled ?? false
                                  }, null, 8 /* PROPS */, ["label", "filter-key", "filter-options-key", "get-options-method", "search-disabled"])
                                ]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_7, " No filters selected ")),
                        _createElementVNode("button", {
                          class: "edit-filters",
                          onClick: _cache[0] || (_cache[0] = $event => ($setup.show_filter_modal = true))
                        }, " Choose filters ")
                      ]),
                      (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
                        _createVNode(_Transition, { name: "fade" }, {
                          default: _withCtx(() => [
                            ($setup.show_filter_modal)
                              ? (_openBlock(), _createBlock($setup["FilterModalComponent"], {
                                  key: 0,
                                  "store-key": "projects",
                                  onCloseModal: _cache[1] || (_cache[1] = $event => ($setup.show_filter_modal = false))
                                }))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _: 1 /* STABLE */
                        })
                      ])),
                      _createVNode($setup["ProjectActiveDropdownFiltersComponent"])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode($setup["TagsFilterComponent"], { "store-key": "projects" })
                    ])
                  ]))
            ], 512 /* NEED_PATCH */), [
              [_vShow, $setup.active_tab !== 'example_projects' && $setup.show_filters]
            ])
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}